module.exports = __webpack_public_path__ + "static/img/voucher01.d604ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question/voucher01.jpg
// module id = ER3R
// module chunks = 4